// User

export enum SLICE_NAMES {
  MY_USER = "my-user",
  LOOKUP = "lookup",
  REVIEW = "review",
  BOOKING = "booking"
}
